import { Button, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { buttonColors, colors } from "../../utility/types/constant";

interface SendInviteBtnProps {
  onClick: () => void;
}

const SendInviteBtn = (props: SendInviteBtnProps) => {
  const { onClick } = props;

  return (
    <Button
      onClick={onClick}
      variant="outlined"
      sx={{
        borderColor: buttonColors.mainPrimary,
        color: colors.mainPrimary,
      }}
      startIcon={<SendIcon />}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: colors.darkGrey,
        }}
      >
        Invite
      </Typography>
    </Button>
  );
};

export default SendInviteBtn;
